import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CwGapiService } from '../../services/cw-gapi.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'xware-googleredirect',
  templateUrl: './googleredirect.component.html',
  styleUrls: ['./googleredirect.component.scss'],
})
export class GoogleredirectComponent implements OnInit {
  constructor(
    public cwGapiService: CwGapiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.cwGapiService.isUserSignedIn()) {
      this.router.navigate(['/login']);
      return;
    }

    sessionStorage.setItem('adType', 'gapi');
    sessionStorage.setItem('portalURL', environment.portalapiurl);
    if (environment.rootUri) {
      sessionStorage.setItem('rooturi', environment.rootUri);
    }

    this.cwGapiService.redirectLogin(true);
  }
}
